// extracted by mini-css-extract-plugin
export default {"container":"go-z","heading":"ho-z","text":"io-z","info":"jo-z","link":"ko-z","fullMaxWidth":"lo-z"};